/* eslint-disable no-case-declarations */
import { HMSVirtualBackgroundTypes } from "@100mslive/hms-virtual-background";

export function getAllVirtualBackgrounds() {
  const backgroundList = [
    {
      id: "blur",
      label: "Blur",
      background: HMSVirtualBackgroundTypes.BLUR,
      backgroundType: HMSVirtualBackgroundTypes.BLUR,
    },
  ];

  const images = [
    { id: "vb-1", label: "Background 1", url: "https://www.100ms.live/images/vb-1.jpeg" },
    { id: "vb-2", label: "Background 2", url: "https://www.100ms.live/images/vb-2.jpg" },
    { id: "vb-3", label: "Background 3", url: "https://www.100ms.live/images/vb-3.png" },
    { id: "hms1", label: "HMS Background 1", url: "https://d2qi07yyjujoxr.cloudfront.net/webapp/vb/hms1.png" },
    { id: "hms2", label: "HMS Background 2", url: "https://d2qi07yyjujoxr.cloudfront.net/webapp/vb/hms2.png" },
    { id: "hms3", label: "HMS Background 3", url: "https://d2qi07yyjujoxr.cloudfront.net/webapp/vb/hms3.png" },
    { id: "hms4", label: "HMS Background 4", url: "https://d2qi07yyjujoxr.cloudfront.net/webapp/vb/hms4.png" },
  ].map(({ id, label, url }) => ({
    id,
    label,
    background: url,
    backgroundType: HMSVirtualBackgroundTypes.IMAGE,
  }));

  backgroundList.push(...images);

  const videoList = [
    { id: "video-1", label: "Video Background 1", url: "https://www.100ms.live/images/video-1.mp4" },
    { id: "video-2", label: "Video Background 2", url: "https://www.100ms.live/images/video-2.mp4" },
    { id: "video-5", label: "Video Background 3", url: "https://www.100ms.live/images/video-5.mp4" },
    { id: "video-7", label: "Video Background 4", url: "https://www.100ms.live/images/video-7.mp4" },
    { id: "video-8", label: "Video Background 5", url: "https://www.100ms.live/images/video-8.mp4" },
  ].map(({ id, label, url }) => ({
    id,
    label,
    background: url,
    backgroundType: HMSVirtualBackgroundTypes.VIDEO,
  }));
  backgroundList.push(...videoList);

  return backgroundList;
}

async function prepareVirtualBackground(virtualBackground) {
  switch (virtualBackground.backgroundType) {
    case HMSVirtualBackgroundTypes.IMAGE: {
      const img = document.createElement("img");
      img.alt = "VB";
      
      // Wait for image to load completely with timeout
      const loadPromise = new Promise((resolve, reject) => {
        img.onload = () => resolve();
        img.onerror = (e) => {
          console.error("Image load error:", virtualBackground.background, e);
          reject(new Error(`Failed to load image: ${virtualBackground.background}`));
        };
      });
      img.src = virtualBackground.background;
      
      // Add timeout for image loading
      const timeoutPromise = new Promise((_, reject) => 
        setTimeout(() => reject(new Error(`Image load timeout: ${virtualBackground.background}`)), 2000)
      );
      
      await Promise.race([loadPromise, timeoutPromise]);
      
      return {
        ...virtualBackground,
        background: img,
      };
    }
    case HMSVirtualBackgroundTypes.VIDEO: {
      const videoEl = document.createElement("video");
      videoEl.loop = true;
      videoEl.muted = true;
      videoEl.playsInline = true;
      videoEl.autoplay = true;
      videoEl.src = virtualBackground.background;
      return {
        ...virtualBackground,
        background: videoEl,
      };
    }
    default:
      return virtualBackground;
  }
}

export async function getVirtualBackgroundById(id) {
  const backgrounds = getAllVirtualBackgrounds();
  const background = backgrounds.find(bg => bg.id === id);
  if (!background) {
    return null;
  }
  return await prepareVirtualBackground(background);
}

export async function getRandomVirtualBackground() {
  const backgroundList = getAllVirtualBackgrounds();
  const randomIdx = Math.floor(Math.random() * backgroundList.length);
  return await prepareVirtualBackground(backgroundList[randomIdx]);
}
